// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__gcJd8","subheader":"ReorderModal_subheader__1g4DL","listWrap":"ReorderModal_listWrap__2sHMt"};